import type { ReactElement } from "react";
import { useAppSelector } from "../hooks";

interface Props {
    children: ReactElement;
}

/**
 * Hides a page from temporary users (admins using "view as company").
 */
export const NonTemporaryUserGate = ({ children }: Props) => {
    const isTemporaryUser = useAppSelector(
        (state) => state.auth.isTemporaryUser,
    );

    if (isTemporaryUser) {
        return null;
    }

    return children;
};
